// extracted by mini-css-extract-plugin
module.exports = {"btnCart":"buttons_btnCart__1givT","customBtn":"buttons_customBtn__3zW1d","userBtn":"buttons_userBtn__Zuww0","yellow":"buttons_yellow__3jU7n","orange":"buttons_orange__3tzzW"};